<template>
  <v-app>
    <v-content>
      
      <v-container class="bckcolor" fluid fill-height>
        
        <v-layout align-center justify-center>
          <v-flex xs12 sm12 md7>
            <v-card flat style="padding:0px;border-radius:0px">
              <v-layout row wrap>
                <v-flex xs6 sm6 md6 class="res">
                  <img class="center" src="../../assets/headlogo.png" style="padding-top:100px"/>
                  <p style="text-align:center;padding:15px;font-size:12px;padding-top:50px" class="txt">
                    We are a multinational medical device company headquartered out of Bonn, Germany. We design, develop, 
                    manufacture, market and distribute a range of 
                    medical products that are used by healthcare establishments in various countries across the globe.
                  </p>

                  <p style="text-align:center;padding:15px;font-size:12px;padding-top:25px" class="txt">
                    L2M is a growing Life Sciences Corporation 
                    specializing in Research, Development, Manufacture of Interventional 
                    Cardiovascular and Endovascular products.

                    The company will provide interventional physicians with innovative vascular devices
                    including coronary stents made in Europe for the world.

                    Minimally Invasive cardiovascular and endovascular products for successful treatment 
                    of Coronary , endovascular and vascular artery disease.
                  </p>
                </v-flex>
                <v-flex xs12 sm12 md6 style="background-color:#E31E24;color:white">  
                   <v-form class="login-form" ref="form" v-model="valid" lazy-validation>
                     <v-layout row wrap style="margin-top:20px">
                       <v-flex xs12 sm12 md12>
                         <h5 class="txtt" style="text-align:left">REGISTER NOW</h5>
                         <h6 class="txt" style="text-align:left;font-size:12px">Please enter your details and we will send your login details on your email</h6>
                       </v-flex>
                       <v-flex xs12 sm12 md12 style="padding-right:20px;">
                          <v-text-field
                          v-model="form.fullName"
                          append-icon="person"
                          label="Enter Your Fullname"
                          type="text"
                          :rules="[rules.required]"
                          required
                          ></v-text-field>
                       </v-flex>
                       <v-flex xs12 sm12 md12 style="padding-right:20px;">
                         <v-text-field
                          v-model="form.email"
                          append-icon="email"
                          label="Enter Your Email ID"
                          type="text"
                          :rules="[rules.email]"
                          required
                          ></v-text-field>
                       </v-flex>
                       <v-flex xs12 sm12 md12 style="padding-right:20px;">
                         <v-text-field
                          v-model="form.mobileNumber"
                          append-icon="call"
                          label="Enter Your Mobile No."
                          type="Number"
                          :rules="[rules.mobileno]"
                          required
                          ></v-text-field>
                       </v-flex>
                       <v-flex xs12 sm12 md12 style="padding-right:20px;">
                          <v-text-field
                          v-model="form.country"
                          append-icon="public"
                          label="Country"
                          type="text"
                          :rules="[rules.required]"
                          required
                          ></v-text-field>
                       </v-flex>
                       <v-flex xs12 sm12 md12 style="padding-right:20px;">
                          <v-text-field
                          v-model="form.companyName"
                          append-icon="account_balance"
                          label="Company name"
                          type="text"
                          :rules="[rules.required]"
                          required
                          ></v-text-field>
                       </v-flex>
                       <v-flex xs12 sm12 md12 style="text-align:right">
                          <v-btn
                            depressed
                            color="primary"
                            :loading="btnSave"
                            class="white--text"
                            @click="onSubmit()"
                          >
                            SUBMIT
                          </v-btn>
                          
                       </v-flex>
                       <v-flex xs12 sm12 md12 style="margin-bottom:-20px">
                         <h6>Want to Login ? <span style="color:#e0e0e0" class="click" @click="login()">Click Here</span></h6>
                       </v-flex>
                       

                     </v-layout>
                  
                </v-form>
                </v-flex>
              </v-layout>
              
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import config from "../../config.json";
//import vuetifyToast from "vuetify-toast";
export default {
  data: () => ({
    valid: true,
    btnSave: false,
    role: sessionStorage.roles,

    form: {
      fullName: null,
      email: null,
      mobileNumber: null,
      country: null,
      companyName: null
    },

    rules: {
      required: value => !!value || "This is empty!",
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid e-mail.";
      },
      mobileno: value => {
          const pattern = /^[1-9]{1}[0-9]{9}$/;
          return pattern.test(value) || "Mobile number not valid!!";
        },
    }
  }),
  props: {
    source: String
  },

  methods: {
    onSubmit() {
      if (this.$refs.form.validate()) {
        this.btnSave = true;
        this.axios
          .post(
            config.API + `Admin`,
            {
              fullName: this.form.fullName,
              email: this.form.email,
              mobileNumber: JSON.parse(this.form.mobileNumber),
              country: this.form.country,
              companyName: this.form.companyName
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
              this.$toaster.success("Login details has been send on your email");
            this.$router.push("/login");
          })
          .catch(err => {
            this.btnSave = false;
            this.$toaster.error("Email id or mobile no is already exist");
          });
      } else {
        this.$toaster.error(`Required field are empty!!`);
      }
    },

    login() {
      this.$router.push("/login");
    },
    

  },
  created() {
  }
  

  
};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Mulish&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Sora:wght@500&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Fugaz+One&display=swap');
</style>
<style lang="css" scoped>
.hdr {
 font-family: 'Fugaz One', cursive;
 font-size: 50px;
 color: #e0e0e0;
}
.hdr1 {
 font-family: 'Fugaz One', cursive;
 color: #e0e0e0;
}
.txt {
 font-family: 'Mulish', sans-serif;
}
.txtt {
 font-family: 'Sora', sans-serif;
}
.lftsid {
  background-color: black !important;
  background-size: cover;
  box-shadow: none !important;
  border-radius: 0px !important;
  height: 350px;
}
.login-form {
  padding: 40px;
}
.bckcolor {
    position: relative;
    background-color: #ffffff;
    background-image: linear-gradient( 36deg, #fff 0%, #d7e1ec 74%);
    box-shadow: inset 0 2px 5px 0px rgb(0 0 0 / 39%);
}
.cursr {
  cursor: pointer;
}
.v-btn {
  margin-left: 0px;
}
.txt_dec:hover {
    text-decoration: underline !important;
}
.click:hover {
  text-decoration: underline !important;
  cursor: pointer;
}
.loginPage {
  background-size:cover
}
.call-button-container {
  margin: auto;
  width: 233px;
  height: 74px;
  vertical-align: middle;
  padding: 10px;
}
@media screen and (max-width: 768px) {
  .res {
    display: none;
  }
}
@media screen and (min-width: 768px){
  .man {
    display: none;
  }
}
</style>
